/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { IRoleMembersHistoryRequest, IRoleMembersHistoryResponse } from "./RoleMembersHistory.api.types";

export const getRoleMembersHistory = async (request: IRoleMembersHistoryRequest): Promise<IRoleMembersHistoryResponse[]> => {
  return (
    await getClientFor(mainApi.name).get(`/events/${request.roleId}/role-assignments/tenants/${request.tenantId}`, {
      params: {
        accountId: request.accountId,
        dateFrom: request.dateFrom,
        dateTo: request.dateTo
      }
    })
  ).data;
};
